import React, { useEffect, useState } from "react"
import { Col, Form, Modal, ModalBody, ModalHeader, Row } from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"
import Select, { SingleValue } from "react-select"
import { useTranslation } from "react-i18next"

interface DeleteCategoryProps {
  isOpen: boolean
  toggle: () => void
}

const categories = [
  { value: "1", label: "Category 1" },
  { value: "2", label: "Category 2" },
  { value: "3", label: "Category 3" },
  { value: "4", label: "Category 4" },
  { value: "5", label: "Category 5" },
]

export const DeleteCategory: React.FC<DeleteCategoryProps> = ({
  isOpen,
  toggle,
}) => {
  const { t } = useTranslation()

  const [selectedCategory, setselectedCategory] = useState<{
    value: string
    label: string
  } | null>(null)

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      action: "",
      category: null,
    },
    validationSchema: Yup.object({
      action: Yup.string().required(
        t("categories_actionValidationMessage") as string
      ),
    }),
    onSubmit: (values, { resetForm }) => {
      if (values.action === "move" && values.category === null) {
        validation.setFieldError(
          "action",
          t("categories_actionValidationMessage2") as string
        )
        return
      }

      resetForm()
      toggle()
    },
  })

  useEffect(() => {
    validation.resetForm()
  }, [isOpen])

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        <p className="text-capitalize fw-semibold font-size-24">
          {t("categories_deleteCategory")}
        </p>
      </ModalHeader>
      <ModalBody>
        <Form
          onSubmit={e => {
            e.preventDefault()
            validation.handleSubmit()
            return false
          }}
        >
          <div
            className="accordion-body py-3"
            style={{
              backgroundColor: "#FCFCFC",
              border: "1px solid #30303014",
              boxShadow: "0px 2px 20px 0px #00000040",
              borderRadius: "8px",
            }}
          >
            <h5 className="fw-semibold font-size-16 text-semi-dark mb-3">
              {t("categories_deleteCategoryMessage")}
            </h5>
            <div className="form-check form-radio-outline form-radio-info mb-3 d-flex align-items-center gap-2">
              <input
                type="radio"
                id="deleteCategoryAndAllProducts"
                name="action"
                value="delete"
                onChange={validation.handleChange}
                checked={validation.values.action === "delete"}
                className="form-check-input"
                style={{ transform: "scale(1.5)" }}
              />
              <label
                className="form-check-label mt-1"
                htmlFor="deleteCategoryAndAllProducts"
              >
                {t("categories_deleteCategoryMessage2")}
              </label>
            </div>
            <div className="form-check form-radio-outline form-radio-info mb-3 d-flex align-items-start gap-2">
              <input
                type="radio"
                id="moveProductsToAnotherCategory"
                name="action"
                value="move"
                onChange={validation.handleChange}
                checked={validation.values.action === "move"}
                className="form-check-input"
                style={{ transform: "scale(1.5)" }}
              />
              <div className="d-flex align-items-start flex-column justify-content-start flex-grow-1">
                <label
                  className="form-check-label"
                  htmlFor="moveProductsToAnotherCategory"
                >
                  {t("categories_moveProducts")}
                </label>
                {validation.values.action === "move" && (
                  <Select
                    id="category"
                    value={selectedCategory}
                    onChange={(
                      selectedOption: SingleValue<{
                        value: string
                        label: string
                      }>
                    ) => {
                      setselectedCategory(selectedOption)
                      validation.setFieldValue("category", {
                        id: selectedOption?.value,
                        name: selectedOption?.label,
                      })
                    }}
                    options={categories.map(one => ({
                      value: one.value,
                      label: one.label,
                    }))}
                    className="select2-selection w-100 mt-2"
                  />
                )}
              </div>
            </div>

            {validation.errors.action && validation.touched.action && (
              <div className="text-danger small mt-1">
                {validation.errors.action}
              </div>
            )}
          </div>

          <Row>
            <Col>
              <div className="d-flex justify-content-start gap-4 mt-4">
                <button
                  type="submit"
                  className="btn bg-gradiant-blue border-0 text-white"
                  disabled={!validation.isValid || !validation.dirty}
                >
                  {t("common_save")}
                </button>
                <button
                  onClick={toggle}
                  type="button"
                  className="btn btn-cancel text-primary border border-primary"
                >
                  {t("common_cancel")}
                </button>
              </div>
            </Col>
          </Row>
        </Form>
      </ModalBody>
    </Modal>
  )
}
